<template>
  <div class="cases" v-if="content">
    <div class="slider">
      <fai class="control control-left" icon="angle-left" @click="previous()"></fai>
      <fai class="control control-right" icon="angle-right" @click="next()"></fai>
      <ul class="dots">
        <li @click="goTo(i)" :class="i === currentSlide ? 'active' : ''" v-for="(dot, i) in Object.keys(content.case)" :key="i">
          <span></span>
        </li>
      </ul>
      <ul class="slides" v-touch:swipe.left="next" v-touch:swipe.right="previous" :style="setPosition(content.case.length)" v-if="content.case">
        <!--           <div @mousemove="animateBackground($event)" class="bg" :style="setBackground(item.img)"></div>
          <div class="slider-content">
            <h2 v-html="item.title"></h2>
        </div>-->
        <li v-for="(blok) in content.case" :key="blok._uid">
          <component :content="blok" :is="blok.component"></component>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import backgroundFollow from "@/mixins/backgroundFollow.js";
export default {
  mixins: [backgroundFollow],
  props: {
    content: null
  },
  data() {
    return {
      currentSlide: 0
    };
  },
  methods: {
    goTo(i) {
      this.currentSlide = i;
    },
    next(d, e) {
      if (e) {
        e.stopImmediatePropagation();
      }

      if (this.currentSlide < this.content.case.length - 1) {
        this.currentSlide++;
      } else {
        this.currentSlide = 0;
      }
    },
    previous(d, e) {
      if (e) {
        e.stopImmediatePropagation();
      }
      if (this.currentSlide == 0) {
        this.currentSlide = this.content.case.length - 1;
      } else {
        this.currentSlide--;
      }
    },
    setPosition(size) {
      return {
        width: size * 100 + "%",
        transform: `translateX(-${(this.currentSlide * 100) / size}%)`
      };
    }
  }
};
</script>

<style lang="scss">
.cases {
  .slider {
    position: relative;
    .slides {
      li {
        height: 100%;
        .class-wrapper {
        }
      }
    }
  }
}
</style>
